import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import { login } from "../../store/thunks";
import "./Login.css";
import Header from "../Header";
import LoginForm from "./LoginForm";
import CreateAccount from "./CreateAccount";
import LoginAccount from "./LoginAccount";

const Login = ({}) => {
  const [step, setStep] = useState("Login");
  const [email, setEmail] = useState("");
  return (
    <Fragment>
      <div className="container-fluid container-fluid-login">
        <Header />
        {step === "Login" && <LoginForm setStep={setStep} setEmail={setEmail}/>}
        {step === "Create" && <CreateAccount setStep={setStep} email={email}/>}
        {step === "LoginAccount" && <LoginAccount email={email}/>}
      </div>
    </Fragment>
  );
};

export default connect(null, {})(Login);
